import './Pagination.scss';

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getLister } from '../../actions/lister-actions';
import { useIsBelowLargeOnly } from '../../hooks/mediaQueries';
import PaginationButton from './PaginationButton';
import PaginationCurrent from './PaginationCurrent';
import PaginationMoreButton from './PaginationMoreButton';
import PaginationPrevButton from './PaginationPrevButton';

export const Pagination = () => {
	const dispatch = useDispatch();
	const { pages, currentPageNumber } = useSelector((state) => state);

	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const isBelowLargeOnly = useIsBelowLargeOnly();

	if (CustomCategoriesEnabled && isBelowLargeOnly) {
		return null;
	}

	const handlePagination = (url) => {
		dispatch(
			getLister(url, {
				type: '',
				trackHistory: true,
			})
		);

		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'auto',
		});
	};

	if (pages) {
		return (
			<ul className="flex justify-center items-center">
				{pages.PreviousPageUrl && (
					<PaginationPrevButton
						handlePagination={handlePagination}
						url={pages.PreviousPageUrl}
					/>
				)}

				{Array.isArray(pages.Pages) &&
					pages.Pages.map((page) => {
						if (currentPageNumber !== page.Index) {
							return (
								<PaginationButton
									handlePagination={handlePagination}
									url={page.Url}
									index={page.Index}
									key={page.Url}
								/>
							);
						}

						return <PaginationCurrent index={page.Index} key={page.Url} />;
					})}

				{pages.NextPageUrl && (
					<PaginationMoreButton
						handlePagination={handlePagination}
						url={pages.NextPageUrl}
					/>
				)}
			</ul>
		);
	}

	return null;
};

export default Pagination;
